<template>
  <b-row>
    <b-col cols="12">
      <voucher-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import VoucherContent from './VoucherContent.vue'

export default {
  components: {
    BRow,
    BCol,

    VoucherContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>